import { render, staticRenderFns } from "./LeadReopenDialog.vue?vue&type=template&id=2096ccf4"
import script from "./LeadReopenDialog.vue?vue&type=script&lang=ts"
export * from "./LeadReopenDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports